interface IconProps {
  className?: string;
  color?: string;
}

export default function OdometerIcon({ className = "", color = "#009804" }: IconProps) {
  return (
    <svg
      width="30"
      height="15"
      viewBox="0 0 300 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Fondo del teclado */}
      <rect
        x="20"
        y="30"
        width="260"
        height="90"
        rx="15"
        ry="15"
        fill="none"
        stroke={color}
        strokeWidth="8"
      />

      {/* Marco interno */}
      <rect
        x="35"
        y="45"
        width="230"
        height="60"
        rx="8"
        ry="8"
        fill="none"
        stroke={color}
        strokeWidth="6"
      />

      {/* Primer número */}
      <text
        x="72.5"
        y="90"
        fontFamily="Arial, sans-serif"
        fontSize="40"
        fontWeight="bold"
        textAnchor="middle"
        fill={color}
      >
        0
      </text>

      {/* Segundo número */}
      <text
        x="120"
        y="90"
        fontFamily="Arial, sans-serif"
        fontSize="40"
        fontWeight="bold"
        textAnchor="middle"
        fill={color}
      >
        0
      </text>

      {/* Tercer número */}
      <text
        x="167"
        y="90"
        fontFamily="Arial, sans-serif"
        fontSize="40"
        fontWeight="bold"
        textAnchor="middle"
        fill={color}
      >
        0
      </text>

      {/* Línea separadora vertical */}
      <rect
        x="196"
        y="60"
        width="8"
        height="30"
        rx="2"
        ry="2"
        fill={color}
      />

      {/* Cuarto número (separado) */}
      <text
        x="232"
        y="90"
        fontFamily="Arial, sans-serif"
        fontSize="40"
        fontWeight="bold"
        textAnchor="middle"
        fill={color}
      >
        0
      </text>

      {/* Círculo superior derecho */}
      <circle cx="260" cy="40" r="5" fill={color} />

      {/* Puntos superiores */}
      <circle cx="95" cy="25" r="5" fill={color} />
      <circle cx="115" cy="25" r="5" fill={color} />

      {/* Puntos inferiores del teclado */}
      <circle cx="85" cy="125" r="5" fill={color} />
      <circle cx="115" cy="125" r="5" fill={color} />
    </svg>
  );
}